import Vue from "vue";
import Slideout from "@hyjiacan/vue-slideout";
import "@hyjiacan/vue-slideout/lib/slideout.css";
// import Slideout component, and set the defaults props

Vue.component("slide-out", Slideout);
